import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING } from 'helper/constants';
import RadioList from 'components/RadioList';
import LiveOffers from './components/LiveOffers';
import ForwardOffers from './components/ForwardOffers';
import ForeignOffers from './components/ForeignOffers';
import OffersInActive from './components/OffersInActive';

const Offers = ({ handleViewDetail, productFilter = [], selectedProductName }) => {
  const [activeTab, setActiveTab] = useState(
    TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.LIVE,
  );

  const handleTabChange = (e) => setActiveTab(e.target.value);

  return (
    <>
      <RadioList
        LIST={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
      />
      <TabContent activeTab={activeTab}>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.LIVE}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.LIVE && (
            <LiveOffers
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FORWARD}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FORWARD && (
            <ForwardOffers
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FOREIGN}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.FOREIGN && (
            <ForeignOffers
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
        <TabPane tabId={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.INACTIVE}>
          {activeTab === TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING.INACTIVE && (
            <OffersInActive
              handleViewDetail={handleViewDetail}
              productFilter={productFilter}
              selectedProductName={selectedProductName}
            />
          )}
        </TabPane>
      </TabContent>
    </>
  );
};

export default Offers;
